import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';

function getAccreditations() {
  return httpService.get(ApiUrl.ACCREDITATIONS);
}

const obj = { getAccreditations };

export default obj;
